export const FIELD_OPTIONS: string[] = [
  'Supplier Id',
  'Supplier Name',
  'City',
  'Country', 
  'VAT Number',
  'Company Number'
];

export const OPERATOR_OPTIONS: string[] = [
  'contains',
  'is',
  'starts with',
  'ends with'
];
